module.exports = __webpack_public_path__ + "static/media/0100.b27b1a4b.png";